import React from "react";
import MuiDrawer from "@material-ui/core/Drawer";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  SvgIcon,
} from "@material-ui/core";

import { DrawerStyles } from "./Drawer.style";

export interface DrawerNavItem {
  key: string;
  label: string;
  icon?: typeof SvgIcon;
}

interface DrawerProps {
  open: boolean;
  items: DrawerNavItem[];
  onSelect: (key: string) => void;
  onClose: (open: boolean) => void;
}

// temporary drawer
export const Drawer: React.FC<DrawerProps> = ({
  open,
  items,
  onSelect,
  onClose,
}) => {
  const styles = DrawerStyles();

  // toogle drawer (open/close)
  const toggleDrawer = (open: boolean) => (
    event: React.KeyboardEvent | React.MouseEvent
  ) => {
    // ignore certain key events
    if (
      event.type === "keydown" &&
      ((event as React.KeyboardEvent).key === "Tab" ||
        (event as React.KeyboardEvent).key === "Shift")
    ) {
      return;
    }
    onClose(open);
  };

  // handle drawer item click
  const handleListItemClick = (key: string) => (
    event: React.KeyboardEvent | React.MouseEvent
  ) => {
    onSelect(key);
    onClose(false);
  };

  // build drawer item list (from props nav items)
  const list = () => (
    <div className={styles.list} role="presentation">
      <List>
        {items.map((item) => (
          <ListItem
            button
            key={item.key}
            onClick={handleListItemClick(item.key)}
          >
            <ListItemIcon>
              {item.icon !== undefined ? <item.icon /> : <div></div>}{" "}
            </ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <>
      <MuiDrawer
        anchor="left"
        open={open}
        onClose={toggleDrawer(false)}
        onKeyDown={toggleDrawer(false)}
      >
        {list()}
      </MuiDrawer>
    </>
  );
};
